import React from 'react'
import Numeral from '../Numeral'
import ILCandidate from '../ILCandidate'
import * as _ from 'lodash'
import ILCampaignDonationChart from '../ILCampaignDonationChart'

const ILCampaignRow = (props) => {
  var candidate = props.candidate
  return (<tr className={props.candidate.primary_winner ? 'primary-winner-row' : 'primary-loser-row'}>
    <td className="image">
      <img src={"../images/" + candidate.img} alt={"Image of " + candidate.name}/>
    </td>
    <td className="candidate">
      <h2>
        <ILCandidate candidate={candidate} />
      </h2>
    </td>
    <td className="raised number">
      <span className="numeral"><Numeral value={candidate.raised}/></span>
      <ILCampaignDonationChart data={candidate.raised_cumulative_timeline} max={105000000} party={candidate.party} scale="sqrt" />
    </td>
    <td className="hide-column-sm self-funded number">
      <span className="numeral"><Numeral value={candidate.self_funded}/></span>
    </td>
    <td className="hide-column-sm raised-past-day number">
      <span className="numeral"><Numeral value={candidate.raised_past_week}/></span>
    </td>
    <td className="raised-30days number">
      <span className="numeral"><Numeral value={candidate.raised_30days}/></span>
      <ILCampaignDonationChart data={candidate.raised_30days_timeline} max={props.dailyMax} party={candidate.party} scale="sqrt" />
    </td>
    <td className="spent number">
      <span className="numeral"><Numeral value={candidate.spent}/></span>
    </td>
  </tr>)
}

const ILCampaignWidget = (props) => {
  var data = props.data.govPrimaryJson.candidates

  // Calc max for chart
  var dailyValues = _.flatten(_.map(data, 'raised_30days_timeline'))
  var dailyMax = _.maxBy(dailyValues, 'amount').amount

  return (<div className="il-campaign-table"><table>
    <thead>
      <tr>
        <th colSpan={3}>Total raised</th>
        <th className="hide-column-sm self-funded number">Self-funded</th>
        <th className="hide-column-sm raised-past-day number">Past week</th>
        <th className="raised-30days number">Past month</th>
        <th className="spent number">Spent</th>
      </tr>
    </thead>

    <tbody>
      {data.map((candidate, i) => (
        <ILCampaignRow key={"candidate"+i} candidate={candidate} dailyMax={dailyMax} />
      ))}
    </tbody>

    <tfoot>
      <tr>
        <td className="primary-winner-label" colSpan={2}>
        </td>
        <td className="raised">
          <span className="number"><Numeral value={props.data.govPrimaryJson.total_raised} /></span>
        </td>
        <td className="hide-column-sm self-funded">
          <span className="number"><Numeral value={props.data.govPrimaryJson.self_funded_total} /></span>
        </td>
        <td className="hide-column-sm raised-past-day">
          <span className="number"><Numeral value={props.data.govPrimaryJson.past_week_total} /></span>
        </td>
        <td className="raised-30days">
          <span className="number"><Numeral value={props.data.govPrimaryJson.past_month_total} /></span>
        </td>
        <td className="spent">
          <span className="number"><Numeral value={props.data.govPrimaryJson.total_spending} /></span>
        </td>
      </tr>
    </tfoot>
  </table></div>)
}

export default ILCampaignWidget



// WEBPACK FOOTER //
// ./src/components/ILCampaignWidget/index.js